export default {"src":"/_next/static/image/public/images/ic_eye_show.ff98bbbef7db652eaab2de4352f71a06.svg","height":13,"width":18};